import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import alumniOfTheMonthService from "./alumniOfTheMonthService"

const initialState = {
    alumns: [],
    isLoading: false,
    isError: false,
    currentPage: 1,
    lastPage: 1,
    perPage: 24,
    alumniDetails: {},
    nextPageURI: null,
    prevPageURI: null,
    pageContent: {},
}

export const fetchAlumnis = createAsyncThunk(
    "alumniOfTheMonth/fetchAlumnis",
    async (currentPage, thunkAPI) => {
        try {
            const { getState } = thunkAPI
            const state = getState().alumniOfTheMonthpage
            return await alumniOfTheMonthService.fetchAlumnis(
                state.perPage,
                currentPage
            )
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString()
            return thunkAPI.rejectWithValue(message)
        }
    }
)

export const fetchPageContent = createAsyncThunk(
    "alumniOfTheMonth/fetchPageContent",
    async (slug, thunkAPI) => {
        try {
            return await alumniOfTheMonthService.fetchPageContent(slug)
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString()
            return thunkAPI.rejectWithValue(message)
        }
    }
)

export const fetchAlumniOfTheMonthDetails = createAsyncThunk(
    "alumniOfTheMonth/fetchAlumniOfTheMonthDetails",
    async (slug, thunkAPI) => {
        try {
            return await alumniOfTheMonthService.fetchAlumniOfTheMonthDetails(
                slug
            )
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString()
            return thunkAPI.rejectWithValue(message)
        }
    }
)

export const alumniOfTheMonthSlice = createSlice({
    name: "alumniOfTheMonth",
    initialState,
    reducers: {
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAlumnis.pending, (state) => {
                state.isLoading = true
                state.alumns = []
            })
            .addCase(fetchAlumnis.fulfilled, (state, action) => {
                state.isLoading = false
                state.alumns = action.payload.data
                state.currentPage = action.payload.current_page
                state.lastPage = action.payload.last_page
                state.nextPageURI = action.payload.next_page_url
                state.prevPageURI = action.payload.prev_page_url
            })
            .addCase(fetchAlumnis.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.alumns = []
                state.currentPage = 1
                state.lastPage = 1
                state.nextPageURI = null
                state.prevPageURI = null
                state.errorMessage = action.payload
            })
            .addCase(fetchPageContent.fulfilled, (state, action) => {
                state.pageContent = action.payload
            })
            .addCase(fetchPageContent.rejected, (state) => {
                state.pageContent = {}
            })
            .addCase(fetchAlumniOfTheMonthDetails.pending, (state) => {
                state.isLoading = true
            })
            .addCase(
                fetchAlumniOfTheMonthDetails.fulfilled,
                (state, action) => {
                    state.isLoading = false
                    state.alumniDetails = action.payload
                }
            )
            .addCase(fetchAlumniOfTheMonthDetails.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.alumniDetails = {}
                state.errorMessage = action.payload
            })
    },
})

export const { setCurrentPage } = alumniOfTheMonthSlice.actions
export default alumniOfTheMonthSlice.reducer
